import { createFeatureSelector, createSelector } from '@ngrx/store'
import { TABLE_NUMBERS_FEATURE_KEY, TableNumbersState, tableNumbersAdapter } from './table-numbers.reducer'

// Lookup the 'TableNumbers' feature state managed by NgRx
export const getTableNumbersState = createFeatureSelector<TableNumbersState>(TABLE_NUMBERS_FEATURE_KEY)

const { selectAll, selectEntities } = tableNumbersAdapter.getSelectors()

export const getTableNumbersLoaded = createSelector(getTableNumbersState, (state: TableNumbersState) => state.loaded)

export const getAllTableNumbers = createSelector(getTableNumbersState, (state: TableNumbersState) => selectAll(state))

export const getTableNumbersEntities = createSelector(getTableNumbersState, (state: TableNumbersState) =>
  selectEntities(state),
)

export const getTableById = (id: string) => createSelector(getTableNumbersEntities, (entities) => entities[id])
